import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { catchError, switchMap, throwError, timeout } from "rxjs";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { SKIP_INTERCEPTOR } from "./tokens";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

    const token = inject(AuthService).token();
    const messageService = inject(MessageService)
    const authService = inject(AuthService);

    let newReq = req;

    if (token) {
        newReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });

    }

    if (req.context.get(SKIP_INTERCEPTOR)) {
        return next(newReq);
    }


    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            console.log(error);

            const backendMessage = error?.error?.message;

            switch (error.status) {
                case 0:
                    messageService.add({
                        severity: 'error',
                        summary: 'Error de conexión',
                        detail: 'Compruebe su conexión a internet.',
                        life: 3000
                    });
                    break;

                case 401:
                    messageService.add({
                        severity: 'error',
                        summary: 'Error ',
                        detail: backendMessage ?? 'Erro desconocido',
                        life: 3000
                    });

                    authService.logout();

                    break;

                default:
                    messageService.add({
                        severity: 'error',
                        summary: 'Error ',
                        detail: backendMessage ?? 'Erro desconocido',
                        life: 3000
                    });
                    break;
            }

            return throwError(() => error);
        })
    );
}
